<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->

  <div v-if="pageLoaded" class="animated fadeIn">
    <b-modal
      id="delJudge"
      ref="delJudge"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>انقضا داور طرح</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <!-- NOTE (b-expire) to expiration of the referee -->
            <b-button
              variant="danger"
              size="lg"
              @click="
                delJudge();
                hideModal('delJudge');
              "
              >انقضا</b-button
            >

            <!-- NOTE (b-cancel) to cancel expiration -->
            <b-button
              variant="warning"
              size="lg"
              class="ml-2"
              @click="hideModal('delJudge')"
              >لغو</b-button
            >
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      آیا از انقضای داوری مطمئن هستید؟
      <br />
      <br />این کار غیر قابل برگشت خواهد بود!
    </b-modal>
    <b-card
      v-if="role == 'referee' && refereeErrorHandler"
      style="border: 0"
      class="shadow p-3 mb-5 bg-white rounded mt-0"
      >با توجه به وضعیت درخواست، داور اجازه دسترسی به اطلاعات را ندارد</b-card
    >
    <b-card v-else style="border: 0" class="mt-0 mb-0">
      <b-card
        v-if="role == 'referee' && proposal.adminToReferee"
        header-bg-variant="danger"
        header-text-variant="white"
        header="پیام ادمین"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
        >{{ proposal.adminToReferee }}</b-card
      >
      <b-card
        v-if="
          role == 'researcher' &&
          (proposal.status == 'نیاز به تکمیل / اصلاح' ||
            proposal.status == 'پیش نویس') &&
          proposal.adminMessage
        "
        header-bg-variant="danger"
        header-text-variant="white"
        header="اصلاحات مورد نیاز"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
        >{{ proposal.adminMessage }}</b-card
      >
      <b-card
        v-if="
          (role == 'admin' || role == 'researcher') &&
          proposal.status == 'رد شده است'
        "
        header-bg-variant="danger"
        header-text-variant="white"
        header="دلایل رد"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
      >
        <li v-for="message in proposal.rejectionIds" :key="message">
          {{ rejectOptions.filter((x) => x.code == message)[0].label }}
        </li>
        <br />
      </b-card>
      <h3>کد مقاله: {{ proposal.requestsCode }}</h3>
      <h4 class="text-dark">وضعیت مقاله: {{ proposal.status }}</h4>
      <hr />
      <b-button
        style="float: left"
        variant="primary"
        v-if="tabIndex == 0"
        @click="saveDocx('doc')"
      >
        <i class="fa fa-file-word-o"></i>
        دریافت Word
      </b-button>
      <b-tabs pills v-model="tabIndex">
        <b-tab title="چکیده مقاله" active lazy>
          <!-- docx -->
          <div v-show="false" id="doc">
            <div class="all" style="text-align: right">
              <h1
                style="
                  display: inline-block;
                  text-align: center;
                  padding: 5px 0;
                  border-bottom: 3px solid black;
                "
              >
                کد مقاله:
                <span
                  style="direction: ltr; font-family: Bahnschrift SemiBold"
                  >{{ proposal.requestsCode }}</span
                >
              </h1>
              <div>
                <h2 style="color: black; direction: rtl">
                  تاریخ خروجی: {{ exportDate }}
                </h2>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات مقاله
                </h2>
                <div>
                  <ul>
                    <li :class="proposal.faSubject ? 'done' : 'required'">
                      <strong>عنوان به زبان فارسی: </strong
                      >{{ proposal.faSubject }}
                    </li>
                    <li :class="proposal.enSubject ? 'done' : 'required'">
                      <strong>عنوان به زبان انگلیسی: </strong
                      >{{ proposal.enSubject }}
                    </li>
                    <li :class="proposal.universityId ? 'done' : 'required'">
                      <strong>دانشگاه محل اجرای مقاله: </strong>
                      {{
                        proposal.universityId
                          ? universities.filter(
                              (x) => x.id == proposal.universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li
                      v-if="proposal.universityId == notUniversity"
                      :class="proposal.otherUniversity ? 'done' : 'required'"
                    >
                      <strong>نام دانشگاه: </strong
                      >{{ proposal.otherUniversity }}
                    </li>
                    <li
                      v-if="proposal.mehvarId != notMehvar"
                      :class="proposal.mehvarId ? 'done' : 'required'"
                    >
                      <strong>محور مقاله: </strong>
                      {{
                        proposal.mehvarId
                          ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            ? mehvars.filter(
                                (x) => x.id == proposal.mehvarId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li
                      v-if="proposal.mehvarId == notMehvar"
                      :class="proposal.mehvarId ? 'done' : 'required'"
                    >
                      <strong>محور مقاله: </strong> سایر محورها
                    </li>
                    <li
                      v-if="proposal.mehvarId == notMehvar"
                      :class="proposal.otherMehvars ? 'done' : 'required'"
                    >
                      <strong>نام محور: </strong>{{ proposal.otherMehvars }}
                    </li>
                    <li>
                      <strong>ماهیت مقاله: </strong>
                      <ul>
                        <li v-if="proposal.typeStudy">مطالعاتی</li>
                        <li v-if="proposal.typeSystemicDevelopmental">
                          سیستمی و توسعه‌ای
                        </li>
                        <li v-if="proposal.typePractical">کاربردی</li>
                      </ul>
                    </li>
                    <li>
                      <strong>حوزه مقاله: </strong>
                      <ul>
                        <li v-if="proposal.zoneMedicine">پزشکی</li>
                        <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                        <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                        <li v-if="proposal.zoneIndustrial">صنعتی</li>
                        <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                        <li v-if="proposal.zoneOther">سایر</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات نویسنده
                </h2>
                <b-table
                  responsive
                  small
                  show-empty
                  bordered
                  head-variant="light"
                  :items="proposal.colleagues"
                  :fields="writersField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
                <strong> آیا نویسنده‌ی مسئول مقاله هستید؟ </strong
                >{{ proposal.responsibleAuthor ? "بله" : "خیر" }} <br />
                <span v-if="!proposal.responsibleAuthor"
                  ><strong>رضایت نامه نویسنده مسئول موجود می باشد؟ </strong
                  >{{
                    proposal.consentResponsibleAuthorFile ? "بله" : "خیر"
                  }}</span
                >
                <ul>
                  <li :class="proposal.executorIBAN ? 'done' : 'required'">
                    <strong>شماره شبا: </strong>{{ proposal.executorIBAN }}
                  </li>
                  <li :class="proposal.executorBankName ? 'done' : 'required'">
                    <strong>نام بانک: </strong>{{ proposal.executorBankName }}
                  </li>
                  <li
                    :class="
                      proposal.executorBankAccountName ? 'done' : 'required'
                    "
                  >
                    <strong>نام صاحب حساب: </strong
                    >{{ proposal.executorBankAccountName }}
                  </li>
                  <li :class="proposal.executorTel ? 'done' : 'required'">
                    <strong>شماره تماس: </strong>{{ proposal.executorTel }}
                  </li>
                </ul>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  مشخصات
                </h2>
                <div>
                  <ul>
                    <li :class="proposal.enSubject ? 'done' : 'required'">
                      <strong>عنوان به زبان انگلیسی: </strong
                      >{{ proposal.enSubject }}
                    </li>
                    <li :class="proposal.abstract ? 'done' : 'required'">
                      <strong>چکیده: </strong><br />{{ proposal.abstract }}
                    </li>
                    <li :class="proposal.keywords ? 'done' : 'required'">
                      <strong>کلید واژگان: </strong><br />{{
                        proposal.keywords
                      }}
                    </li>
                    <li :class="proposal.doi ? 'done' : 'required'">
                      <strong>شناسه دیجیتال مجله: </strong
                      ><span
                        style="
                          direction: ltr;
                          font-family: Bahnschrift SemiBold;
                        "
                        >{{ proposal.doi }}</span
                      >
                    </li>
                    <li :class="proposal.ISSN ? 'done' : 'required'">
                      <strong>ISSN مجله: </strong>
                      <div v-if="proposal.ISSN">
                        <span
                          v-for="(item, index) in proposal.ISSN"
                          :key="index"
                          class="badge"
                          style="font-size: 15px"
                        >
                          {{ item }}
                          <span v-if="index != proposal.ISSN.length - 1"
                            >,</span
                          >
                        </span>
                      </div>
                    </li>

                    <li :class="proposal.impactFactor ? 'done' : 'required'">
                      <strong>ضریب تاثیر مجله: </strong
                      >{{ proposal.impactFactor }}
                    </li>
                    <li :class="proposal.acknowledgment ? 'done' : 'required'">
                      <strong>تشکرات: </strong><br />{{
                        proposal.acknowledgment
                      }}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  زمان‌بندی
                </h2>
                <ul>
                  <li
                    :class="
                      proposal.articlePublicationDate ? 'done' : 'required'
                    "
                  >
                    <strong>تاریخ چاپ (شمسی): </strong
                    ><span style="direction: ltr; font-family: B Nazanin">{{
                      proposal.articlePublicationDate
                    }}</span>
                  </li>
                  <li
                    :class="
                      proposal.articlePublicationDate ? 'done' : 'required'
                    "
                  >
                    <strong>تاریخ چاپ (میلادی): </strong>
                    <span>{{
                      proposal.articlePublicationDate
                        ? moment(
                            proposal.articlePublicationDate,
                            "jYYYY/jMM/jDD"
                          ).format("DD/MM/YYYY")
                        : "-"
                    }}</span>
                  </li>
                  <li
                    :class="
                      proposal.articleSubmissionDate ? 'done' : 'required'
                    "
                  >
                    <strong>تاریخ ثبت (شمسی): </strong
                    ><span style="direction: ltr">{{
                      proposal.articleSubmissionDate
                    }}</span>
                  </li>
                  <li
                    :class="
                      proposal.articleSubmissionDate ? 'done' : 'required'
                    "
                  >
                    <strong>تاریخ ثبت (میلادی): </strong>
                    {{
                      proposal.articleSubmissionDate
                        ? moment(
                            proposal.articleSubmissionDate,
                            "jYYYY/jMM/jDD"
                          ).format("DD/MM/YYYY")
                        : "-"
                    }}
                  </li>
                  <li
                    :class="proposal.articleRevisionDate ? 'done' : 'required'"
                  >
                    <strong>تاریخ بازبینی (شمسی): </strong
                    ><span style="direction: ltr">{{
                      proposal.articleRevisionDate
                    }}</span>
                  </li>
                  <li
                    :class="proposal.articleRevisionDate ? 'done' : 'required'"
                  >
                    <strong>تاریخ بازبینی (میلادی): </strong
                    >{{
                      proposal.articleRevisionDate
                        ? moment(
                            proposal.articleRevisionDate,
                            "jYYYY/jMM/jDD"
                          ).format("DD/MM/YYYY")
                        : "-"
                    }}
                  </li>
                  <li
                    :class="
                      proposal.articleAcceptanceDate ? 'done' : 'required'
                    "
                  >
                    <strong>تاریخ پذیرش (شمسی): </strong
                    ><span style="direction: ltr">{{
                      proposal.articleAcceptanceDate
                    }}</span>
                  </li>
                  <li
                    :class="
                      proposal.articleAcceptanceDate ? 'done' : 'required'
                    "
                  >
                    <strong>تاریخ پذیرش (میلادی): </strong
                    >{{
                      proposal.articleAcceptanceDate
                        ? moment(
                            proposal.articleAcceptanceDate,
                            "jYYYY/jMM/jDD"
                          ).format("DD/MM/YYYY")
                        : "-"
                    }}
                  </li>
                  <li
                    :class="proposal.articleReleaseDate ? 'done' : 'required'"
                  >
                    <strong>تاریخ انتشار (شمسی): </strong
                    ><span style="direction: ltr">{{
                      proposal.articleReleaseDate
                    }}</span>
                  </li>
                  <li
                    :class="proposal.articleReleaseDate ? 'done' : 'required'"
                  >
                    <strong>تاریخ انتشار (میلادی): </strong
                    >{{
                      proposal.articleReleaseDate
                        ? moment(
                            proposal.articleReleaseDate,
                            "jYYYY/jMM/jDD"
                          ).format("DD/MM/YYYY")
                        : "-"
                    }}
                  </li>
                </ul>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  میزان وجه تشویقی
                </h2>
                <div>
                  <strong>مبلغ: </strong>
                  <span
                    style="font-size: 16px"
                    v-if="
                      0 < proposal.impactFactor && proposal.impactFactor < 4
                    "
                  >
                    2,000,000 تومان
                  </span>
                  <span
                    style="font-size: 16px"
                    v-else-if="
                      4 <= proposal.impactFactor && proposal.impactFactor <= 8
                    "
                  >
                    3,000,000 تومان
                  </span>
                  <span
                    style="font-size: 16px"
                    v-else-if="proposal.impactFactor > 8"
                  >
                    4,000,000 تومان
                  </span>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  تعهدات
                </h2>
                <div>
                  <ul>
                    <li v-if="proposal.promiseArrays[0]">
                      این مقاله در بخش حمایت از رساله های دکتری و یا در بخش
                      حمایت از پایان نامه های ارشد زیست فناوری مورد حمایت قرار
                      نگرفته است.
                    </li>
                    <li v-if="proposal.promiseArrays[1]">
                      ملاک IF بر اساس JCR سال 2018 مورد تایید خواهد بود.
                    </li>
                    <li v-if="proposal.promiseArrays[2]">
                      ملاک میزان حمایت میزان دقیق IF خواهد بود.
                    </li>
                    <li v-if="proposal.promiseArrays[3]">
                      ثبت در خواست هیچگونه حقی برای پذیرش مقاله ایجاد نمی کند.
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <!-- docx -->
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1 border-0" role="tab">
              <b-button block v-b-toggle.accordion-2 variant="dark">
                <h5 class="mb-0" style="display: inline-block">
                  اطلاعات مقاله
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-2"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <ul>
                    <li>
                      <strong class="text-primary"
                        >عنوان به زبان فارسی:
                      </strong>
                      {{ proposal.faSubject }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >عنوان به زبان انگلیسی:
                      </strong>
                      {{ proposal.enSubject }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >دانشگاه محل اجرای مقاله:
                      </strong>

                      {{
                        proposal.universityId
                          ? universities.filter(
                              (x) => x.id == proposal.universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li v-if="proposal.universityId == notUniversity">
                      <strong class="text-primary">نام دانشگاه: </strong>
                      {{ proposal.otherUniversity }}
                    </li>
                    <li v-if="proposal.mehvarId != notMehvar">
                      <strong class="text-primary">محور مقاله: </strong>
                      {{
                        proposal.mehvarId
                          ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            ? mehvars.filter(
                                (x) => x.id == proposal.mehvarId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li v-if="proposal.mehvarId == notMehvar">
                      <strong class="text-primary">محور مقاله: </strong> سایر
                      محورها
                    </li>
                    <li v-if="proposal.mehvarId == notMehvar">
                      <strong class="text-primary">نام محور: </strong
                      >{{ proposal.otherMehvars }}
                    </li>
                    <li>
                      <strong class="text-primary">ماهیت مقاله: </strong>
                      <b-form-group disabled>
                        <b-form-checkbox v-model="proposal.typeStudy"
                          >مطالعاتی</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-model="proposal.typeSystemicDevelopmental"
                          >سیستمی و توسعه‌ای</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.typePractical"
                          >کاربردی</b-form-checkbox
                        >
                      </b-form-group>
                    </li>
                    <li>
                      <strong class="text-primary">حوزه مقاله: </strong>
                      <b-form-group disabled>
                        <b-form-checkbox v-model="proposal.zoneMedicine"
                          >پزشکی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneAgriculture"
                          >کشاورزی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneEnvironment"
                          >محیط زیست</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneIndustrial"
                          >صنعتی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneBioComputing"
                          >رایانش زیستی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneOther"
                          >سایر</b-form-checkbox
                        >
                      </b-form-group>
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-3 variant="light">
                <h5 class="mb-0" style="display: inline-block">
                  اطلاعات نویسنده
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-3"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <b-table
                    responsive
                    small
                    show-empty
                    bordered
                    head-variant="light"
                    :items="proposal.colleagues"
                    :fields="writersField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                  <b-form-group disabled>
                    <div class="d-flex mt-4" dir="rtl">
                      <b-form-checkbox
                        v-model="proposal.responsibleAuthor"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6 class="text-primary">
                          نویسنده‌ی مسئول مقاله هستم
                        </h6></label
                      >
                    </div>
                  </b-form-group>
                  <li v-if="!proposal.responsibleAuthor">
                    <strong class="text-primary"
                      >رضایتنامه نویسنده مسئول:
                    </strong>
                    <a
                      v-if="proposal.consentResponsibleAuthorFile"
                      :href="proposal.consentResponsibleAuthorFile"
                      target="blank"
                      >دانلود</a
                    >
                    <span v-else> -- </span>
                  </li>
                  <br />
                  <li>
                    <strong class="text-primary">شماره شبا: </strong
                    >{{ proposal.executorIBAN }}
                  </li>
                  <li>
                    <strong class="text-primary">نام بانک: </strong
                    >{{ proposal.executorBankName }}
                  </li>
                  <li>
                    <strong class="text-primary">نام صاحب حساب: </strong
                    >{{ proposal.executorBankAccountName }}
                  </li>
                  <li>
                    <strong class="text-primary">شماره تماس: </strong
                    >{{ proposal.executorTel }}
                  </li>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-4 variant="warning">
                <h5 class="mb-0" style="display: inline-block">مشخصات</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-4"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <ul>
                    <li>
                      <strong class="text-primary"
                        >عنوان به زبان انگلیسی: </strong
                      >{{ proposal.enSubject }}
                    </li>
                    <li>
                      <strong class="text-primary">چکیده: </strong
                      >{{ proposal.abstract }}
                    </li>
                    <li>
                      <strong class="text-primary">کلید واژگان: </strong
                      >{{ proposal.keywords }}
                    </li>
                    <li>
                      <strong class="text-primary">شناسه دیجیتال مجله: </strong>
                      <span dir="ltr">{{ proposal.doi }}</span>
                    </li>
                    <li>
                      <strong class="text-primary">ISSN مجله: </strong>
                      <div v-if="proposal.ISSN">
                        <div
                          v-for="(item, index) in proposal.ISSN"
                          :key="index"
                          class="badge"
                        >
                          <h6 class="mb-0">
                            <b-badge style="font-size: 13px !important" pill>{{
                              item
                            }}</b-badge>
                          </h6>
                        </div>
                      </div>
                    </li>

                    <li>
                      <strong class="text-primary">ضریب تاثیر مجله: </strong
                      >{{ proposal.impactFactor }}
                    </li>
                    <li>
                      <strong class="text-primary">تشکرات: </strong
                      >{{ proposal.acknowledgment }}
                    </li>
                    <li>
                      <strong class="text-primary">فایل PDF مقاله: </strong>
                      <a
                        v-if="proposal.articlePdfFile"
                        :href="proposal.articlePdfFile"
                        target="blank"
                        >دانلود</a
                      >
                      <span v-else> -- </span>
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-5 variant="info">
                <h5 class="mb-0 text-white" style="display: inline-block">
                  زمانبندی
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-5"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <ul>
                    <li>
                      <strong class="text-primary">تاریخ چاپ (شمسی): </strong
                      >{{ proposal.articlePublicationDate }}
                    </li>
                    <li>
                      <strong class="text-primary">تاریخ چاپ (میلادی): </strong>
                      {{
                        proposal.articlePublicationDate
                          ? moment(
                              proposal.articlePublicationDate,
                              "jYYYY/jMM/jDD"
                            ).format("YYYY/MM/DD")
                          : "-"
                      }}
                    </li>
                    <li>
                      <strong class="text-primary">تاریخ ثبت (شمسی): </strong
                      >{{ proposal.articleSubmissionDate }}
                    </li>
                    <li>
                      <strong class="text-primary">تاریخ ثبت (میلادی): </strong>
                      {{
                        proposal.articleSubmissionDate
                          ? moment(
                              proposal.articleSubmissionDate,
                              "jYYYY/jMM/jDD"
                            ).format("YYYY/MM/DD")
                          : "-"
                      }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >تاریخ بازبینی (شمسی): </strong
                      >{{ proposal.articleRevisionDate }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >تاریخ بازبینی (میلادی): </strong
                      >{{
                        proposal.articleRevisionDate
                          ? moment(
                              proposal.articleRevisionDate,
                              "jYYYY/jMM/jDD"
                            ).format("YYYY/MM/DD")
                          : "-"
                      }}
                    </li>
                    <li>
                      <strong class="text-primary">تاریخ پذیرش (شمسی): </strong
                      >{{ proposal.articleAcceptanceDate }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >تاریخ پذیرش (میلادی): </strong
                      >{{
                        proposal.articleAcceptanceDate
                          ? moment(
                              proposal.articleAcceptanceDate,
                              "jYYYY/jMM/jDD"
                            ).format("YYYY/MM/DD")
                          : "-"
                      }}
                    </li>
                    <li>
                      <strong class="text-primary">تاریخ انتشار (شمسی): </strong
                      >{{ proposal.articleReleaseDate }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >تاریخ انتشار (میلادی): </strong
                      >{{
                        proposal.articleReleaseDate
                          ? moment(
                              proposal.articleReleaseDate,
                              "jYYYY/jMM/jDD"
                            ).format("YYYY/MM/DD")
                          : "-"
                      }}
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-6 variant="warning">
                <h5 class="mb-0" style="display: inline-block">
                  میزان وجه تشویقی
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-6"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="p-3 shadow">
                  <ul>
                    <b-form-group label="مبلغ:">
                      <div
                        v-if="
                          0 < proposal.impactFactor && proposal.impactFactor < 4
                        "
                      >
                        <h3 class="text-primary">2,000,000 تومان</h3>
                      </div>
                      <div
                        v-else-if="
                          4 <= proposal.impactFactor &&
                          proposal.impactFactor <= 8
                        "
                      >
                        <h3 class="text-primary">3,000,000 تومان</h3>
                      </div>
                      <div v-else-if="proposal.impactFactor > 8">
                        <h3 class="text-primary">4,000,000 تومان</h3>
                      </div>
                    </b-form-group>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-7 variant="dark">
                <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-7"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <b-form-group disabled>
                    <b-form-checkbox
                      :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[0]"
                      >این مقاله در بخش حمایت از رساله های دکتری و یا در بخش
                      حمایت از پایان نامه های ارشد زیست فناوری مورد حمایت قرار
                      نگرفته است.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[1]"
                      >ملاک IF بر اساس JCR سال 2018 مورد تایید خواهد
                      بود.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[2]"
                      >ملاک میزان حمایت میزان دقیق IF خواهد
                      بود.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[3]"
                      >ثبت در خواست هیچگونه حقی برای پذیرش مقاله ایجاد نمی
                      کند.</b-form-checkbox
                    ></b-form-group
                  >
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'admin' || role == 'manager'" title="داوری">
          <!-- NOTE (t-review) to show the reviews list -->
          <b-table
            responsive
            small
            show-empty
            head-variant="dark"
            :items="reviews"
            :fields="judgementFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary my-3"
          >
            <template v-slot:cell(description)="row">
              <b-button
                size="sm"
                @click="row.toggleDetails"
                class="mr-2"
                :variant="row.detailsShowing ? 'danger' : 'success'"
                v-show="row.item.status == 'Done'"
                >{{ row.detailsShowing ? "بستن" : "نمایش" }} داوری</b-button
              >&nbsp;
              <!-- NOTE (b-expire) to expiration of the refree -->
              <b-button
                size="sm"
                @click="removeJudge(row)"
                variant="warning"
                class="mr-2"
                v-show="
                  row.item.status != 'Expired' &&
                  row.item.status != 'Done' &&
                  role != 'manager'
                "
                >انقضا داوری</b-button
              >
            </template>
            <template v-slot:row-details="row">
              <Review
                :disabled="true"
                :scoresData="row.item.scores"
                :refereeIdea="row.item.description"
                :refereeDecision="row.item.decisionEn"
              />
            </template>
            <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
            <template v-slot:cell(status)="data">
              {{ statusDictionary.find((x) => x.en == data.value).fa }}
            </template>
          </b-table>
        </b-tab>
        <b-tab v-if="role == 'admin' || role == 'manager'" title="تاریخچه">
          <span v-if="!proposal.history.length"
            >تاریخچه‌ای برای نمایش وجود ندارد.</span
          >
          <!-- :text-variant="'white'" -->
          <b-card
            v-else
            :bg-variant="computedVariant(index)"
            v-for="(p, index) in computedJournals"
            :key="index"
            style="max-width: 80%"
            class="mb-3 border-0 shadow"
          >
            <template slot="header">
              <b-row>
                <b-col>
                  <h5>{{ p.name }}</h5>
                </b-col>
                <b-col>
                  <div style="float: left">
                    <h5>{{ p.date }}</h5>
                  </div>
                </b-col>
              </b-row>
            </template>

            <h6>{{ p.message }}</h6>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'admin'" title="مدیریت وضعیت">
          <b-form-group id="fieldset-1" description label="وضعیت طرح">
            <b-form-group>
              <Select2
                v-model="selectedSituation"
                :options="situationsOptions"
                :settings="{ width: '75%' }"
              ></Select2>
              <!-- <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select> -->
            </b-form-group>
            <div v-if="selectedSituation == 8">
              <b-row>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2 text-danger">
                  تذکر: لطفا توجه داشته باشد که متن نگارش شده توسط شما بدون
                  تغییر در اختیار کاربر قرار خواهد گرفت
                </p>
              </b-row>
            </div>
            <div v-if="selectedSituation == 3">
              <b-form-group label="داوران">
                <v-select
                  multiple
                  :reduce="(x) => x.code"
                  :options="reviewersOptions"
                  style="direction: rtl"
                  v-model="reviewers"
                >
                  <template v-slot:option="option">
                    <div class="text-right">
                      {{ option.label
                      }}<b-badge class="m-1 p-1" variant="info"
                        >کل {{ option.all }}</b-badge
                      ><b-badge class="m-1 p-1" variant="success"
                        >انجام شده {{ option.dones }}</b-badge
                      ><b-badge class="m-1 p-1" variant="danger"
                        >لغو شده {{ option.expireds }}</b-badge
                      ><b-badge class="m-1 p-1" variant="warning"
                        >در جریان {{ option.ongoings }}</b-badge
                      >
                    </div>
                  </template>
                </v-select>
              </b-form-group>
              <div v-if="reviewers.length">
                <div class="mb-2">داوران انتخاب شده</div>
                <div
                  class="selected-referees"
                  v-for="(item, index) in computedSelectedReferees"
                  :key="index"
                >
                  <v-card>
                    <v-card-title>{{ item.label }}</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col>داوری‌های دعوت شده: {{ item.all }}</v-col>
                        <v-col>داوری‌های انجام شده: {{ item.dones }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>داوری‌های در جریان: {{ item.ongoings }}</v-col>
                        <v-col>داوری‌های لغو شده: {{ item.expireds }}</v-col>
                      </v-row>
                      <v-row v-if="item.tags.length != 0">
                        <v-col class="selected-referees__tags">
                          <h6>برچسب‌های داور</h6>
                          <div>
                            <b-badge
                              class="tag"
                              v-for="(tag, index2) in item.tags"
                              :key="index2"
                              variant="primary"
                              >{{ tag }}</b-badge
                            >
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </div>
            <b-form-group
              label="دلایل رد درخواست"
              v-else-if="selectedSituation == 9"
            >
              <v-select
                multiple
                :reduce="(x) => x.code"
                :options="rejectOptions"
                v-model="proposal.rejectionIds"
              >
              </v-select>
            </b-form-group>
            <b-form-group v-else-if="selectedStatus == 3"></b-form-group>
            <b-form-group
              v-if="selectedSituation == 3"
              label="یادداشت برای داور:"
            >
              <b-form-textarea v-model="proposal.adminToReferee">
              </b-form-textarea>
            </b-form-group>
            <b-form-group label="یادداشت" class="mt-4">
              <b-form-textarea
                trim
                id="textarea"
                aria-describedby="proposal.description"
                v-model="proposal.description"
                :state="
                  selectedSituation == 8
                    ? proposal.description
                      ? null
                      : false
                    : null
                "
                width="75%"
                placeholder="نظرات خود را اینجا وارد نمایید"
                rows="8"
                max-rows="10"
              ></b-form-textarea>

              <b-form-invalid-feedback
                id="proposal.description"
                :state="
                  selectedStatus == 'نیاز به تکمیل / اصلاح'
                    ? proposal.description
                      ? null
                      : false
                    : null
                "
                >با نوشتن نظر خود میتوانید پژوهشگر را در انجام اصلاحات مورد نیاز
                راهنمایی کنید</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group>
              <!-- NOTE (b-editProposal) to submit the proposal changes -->
              <b-button
                :disabled="disableEditProposal"
                @click="
                  editProposal(
                    situationsOptions.filter(
                      (x) => x.id == selectedSituation
                    )[0].eng
                  )
                "
                >ثبت</b-button
              >
            </b-form-group>
          </b-form-group>
        </b-tab>
        <b-tab v-if="proposal.isArchive" title="نسخه‌های پیشین">
          <b-tabs vertical pills fill>
            <b-tab v-for="(old, index) in proposal.archives" :key="index">
              <template slot="title">
                <div class="d-flex flex-column align-items-center">
                  {{ "نسخه" + " " + Number(proposal.archives.length - index) }}
                  <p class="mb-0">({{ old.registerDate }})</p>
                </div>
              </template>
              <b-tabs pills>
                <b-tab title="چکیده مقاله" active lazy>
                  <b-card no-body class="mb-1">
                    <b-card-header
                      header-tag="header"
                      class="p-1 border-0"
                      role="tab"
                    >
                      <b-button block v-b-toggle.accordion-2 variant="dark">
                        <h5 class="mb-0" style="display: inline-block">
                          اطلاعات مقاله
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-2"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <ul>
                            <li>
                              <strong class="text-primary"
                                >عنوان به زبان فارسی:
                              </strong>
                              {{ old.faSubject }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >عنوان به زبان انگلیسی:
                              </strong>
                              {{ old.enSubject }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >دانشگاه محل اجرای مقاله:
                              </strong>

                              {{
                                old.universityId
                                  ? universities.filter(
                                      (x) => x.id == old.universityId
                                    )[0]
                                    ? universities.filter(
                                        (x) => x.id == old.universityId
                                      )[0].text
                                    : ""
                                  : ""
                              }}
                            </li>
                            <li v-if="old.universityId == notUniversity">
                              <strong class="text-primary"
                                >نام دانشگاه:
                              </strong>
                              {{ old.otherUniversity }}
                            </li>
                            <li v-if="old.mehvarId != notMehvar">
                              <strong class="text-primary">محور مقاله: </strong>
                              {{
                                old.mehvarId
                                  ? mehvars.filter(
                                      (x) => x.id == old.mehvarId
                                    )[0]
                                    ? mehvars.filter(
                                        (x) => x.id == old.mehvarId
                                      )[0].text
                                    : ""
                                  : ""
                              }}
                            </li>
                            <li v-if="old.mehvarId == notMehvar">
                              <strong class="text-primary">محور مقاله: </strong>
                              سایر محورها
                            </li>
                            <li v-if="old.mehvarId == notMehvar">
                              <strong class="text-primary">نام محور: </strong
                              >{{ old.otherMehvars }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >ماهیت مقاله:
                              </strong>
                              <b-form-group disabled>
                                <b-form-checkbox v-model="old.typeStudy"
                                  >مطالعاتی</b-form-checkbox
                                >
                                <b-form-checkbox
                                  v-model="old.typeSystemicDevelopmental"
                                  >سیستمی و توسعه‌ای</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.typePractical"
                                  >کاربردی</b-form-checkbox
                                >
                              </b-form-group>
                            </li>
                            <li>
                              <strong class="text-primary">حوزه مقاله: </strong>
                              <b-form-group disabled>
                                <b-form-checkbox v-model="old.zoneMedicine"
                                  >پزشکی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneAgriculture"
                                  >کشاورزی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneEnvironment"
                                  >محیط زیست</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneIndustrial"
                                  >صنعتی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneBioComputing"
                                  >رایانش زیستی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneOther"
                                  >سایر</b-form-checkbox
                                >
                              </b-form-group>
                            </li>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-3 variant="light">
                        <h5 class="mb-0" style="display: inline-block">
                          اطلاعات نویسنده
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-3"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <b-table
                            responsive
                            small
                            show-empty
                            bordered
                            head-variant="light"
                            :items="old.colleagues"
                            :fields="writersField"
                            empty-text="رکوردی برای نمایش وجود ندارد"
                            class="table table-secondary"
                          >
                            <template v-slot:head()="data">
                              <div
                                style="
                                  text-align: center;
                                  vertical-align: middle;
                                "
                              >
                                {{ data.label }}
                              </div>
                            </template>
                            <template v-slot:cell()="data">
                              <div
                                style="
                                  text-align: center;
                                  vertical-align: middle;
                                "
                              >
                                {{ data.value }}
                              </div>
                            </template>
                            <template v-slot:cell(index)="data">
                              <div
                                style="
                                  text-align: center;
                                  vertical-align: middle;
                                "
                              >
                                {{ data.index + 1 }}
                              </div>
                            </template>
                          </b-table>
                          <b-form-group disabled>
                            <div class="d-flex mt-4" dir="rtl">
                              <b-form-checkbox
                                v-model="old.responsibleAuthor"
                              ></b-form-checkbox>
                              <label class="ml-2"
                                ><h6 class="text-primary">
                                  نویسنده‌ی مسئول مقاله هستم
                                </h6></label
                              >
                            </div>
                          </b-form-group>
                          <li v-if="!old.responsibleAuthor">
                            <strong class="text-primary"
                              >رضایتنامه نویسنده مسئول:
                            </strong>
                            <a
                              v-if="old.consentResponsibleAuthorFile"
                              :href="old.consentResponsibleAuthorFile"
                              target="blank"
                              >دانلود</a
                            >
                            <span v-else> -- </span>
                          </li>
                          <br />
                          <li>
                            <strong class="text-primary">شماره شبا: </strong
                            >{{ old.executorIBAN }}
                          </li>
                          <li>
                            <strong class="text-primary">نام بانک: </strong
                            >{{ old.executorBankName }}
                          </li>
                          <li>
                            <strong class="text-primary">نام صاحب حساب: </strong
                            >{{ old.executorBankAccountName }}
                          </li>
                          <li>
                            <strong class="text-primary">شماره تماس: </strong
                            >{{ old.executorTel }}
                          </li>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-4 variant="warning">
                        <h5 class="mb-0" style="display: inline-block">
                          مشخصات
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-4"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <ul>
                            <li>
                              <strong class="text-primary"
                                >عنوان به زبان انگلیسی: </strong
                              >{{ old.enSubject }}
                            </li>
                            <li>
                              <strong class="text-primary">چکیده: </strong
                              >{{ old.abstract }}
                            </li>
                            <li>
                              <strong class="text-primary">کلید واژگان: </strong
                              >{{ old.keywords }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >شناسه دیجیتال مجله:
                              </strong>
                              <span dir="ltr">{{ old.doi }}</span>
                            </li>
                            <li>
                              <strong class="text-primary">ISSN مجله: </strong>
                              <div v-if="proposal.ISSN">
                                <div
                                  v-for="(item, index) in proposal.ISSN"
                                  :key="index"
                                  class="badge"
                                >
                                  <h6 class="mb-0">
                                    <b-badge
                                      style="font-size: 13px !important"
                                      pill
                                      >{{ item }}</b-badge
                                    >
                                  </h6>
                                </div>
                              </div>
                            </li>

                            <li>
                              <strong class="text-primary"
                                >ضریب تاثیر مجله: </strong
                              >{{ old.impactFactor }}
                            </li>
                            <li>
                              <strong class="text-primary">تشکرات: </strong
                              >{{ old.acknowledgment }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >فایل PDF مقاله:
                              </strong>
                              <a
                                v-if="old.articlePdfFile"
                                :href="old.articlePdfFile"
                                target="blank"
                                >دانلود</a
                              >
                              <span v-else> -- </span>
                            </li>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-5 variant="info">
                        <h5
                          class="mb-0 text-white"
                          style="display: inline-block"
                        >
                          زمانبندی
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-5"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <ul>
                            <li>
                              <strong class="text-primary"
                                >تاریخ چاپ (شمسی): </strong
                              >{{ old.articlePublicationDate }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >تاریخ چاپ (میلادی):
                              </strong>
                              {{
                                old.articlePublicationDate
                                  ? moment(
                                      old.articlePublicationDate,
                                      "jYYYY/jMM/jDD"
                                    ).format("YYYY/MM/DD")
                                  : "-"
                              }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >تاریخ ثبت (شمسی): </strong
                              >{{ old.articleSubmissionDate }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >تاریخ ثبت (میلادی):
                              </strong>
                              {{
                                old.articleSubmissionDate
                                  ? moment(
                                      old.articleSubmissionDate,
                                      "jYYYY/jMM/jDD"
                                    ).format("YYYY/MM/DD")
                                  : "-"
                              }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >تاریخ بازبینی (شمسی): </strong
                              >{{ old.articleRevisionDate }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >تاریخ بازبینی (میلادی): </strong
                              >{{
                                old.articleRevisionDate
                                  ? moment(
                                      old.articleRevisionDate,
                                      "jYYYY/jMM/jDD"
                                    ).format("YYYY/MM/DD")
                                  : "-"
                              }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >تاریخ پذیرش (شمسی): </strong
                              >{{ old.articleAcceptanceDate }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >تاریخ پذیرش (میلادی): </strong
                              >{{
                                old.articleAcceptanceDate
                                  ? moment(
                                      old.articleAcceptanceDate,
                                      "jYYYY/jMM/jDD"
                                    ).format("YYYY/MM/DD")
                                  : "-"
                              }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >تاریخ انتشار (شمسی): </strong
                              >{{ old.articleReleaseDate }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >تاریخ انتشار (میلادی): </strong
                              >{{
                                old.articleReleaseDate
                                  ? moment(
                                      old.articleReleaseDate,
                                      "jYYYY/jMM/jDD"
                                    ).format("YYYY/MM/DD")
                                  : "-"
                              }}
                            </li>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-6 variant="warning">
                        <h5 class="mb-0" style="display: inline-block">
                          میزان وجه تشویقی
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-6"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="p-3 shadow">
                          <ul>
                            <b-form-group label="مبلغ:">
                              <div
                                v-if="
                                  0 < old.impactFactor && old.impactFactor < 4
                                "
                              >
                                <h3 class="text-primary">2,000,000 تومان</h3>
                              </div>
                              <div
                                v-else-if="
                                  4 <= old.impactFactor && old.impactFactor <= 8
                                "
                              >
                                <h3 class="text-success">3,000,000 تومان</h3>
                              </div>
                              <div v-else-if="old.impactFactor > 8">
                                <h3 class="text-success">4,000,000 تومان</h3>
                              </div>
                            </b-form-group>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-7 variant="dark">
                        <h5 class="mb-0" style="display: inline-block">
                          تعهدات
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-7"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <b-form-group disabled>
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[0] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[0]"
                              >این مقاله در بخش حمایت از رساله های دکتری و یا در
                              بخش حمایت از پایان نامه های ارشد زیست فناوری مورد
                              حمایت قرار نگرفته است.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[1] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[1]"
                              >ملاک IF بر اساس JCR سال 2018 مورد تایید خواهد
                              بود.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[2] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[2]"
                              >ملاک میزان حمایت میزان دقیق IF خواهد
                              بود.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[3] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[3]"
                              >ثبت در خواست هیچگونه حقی برای پذیرش مقاله ایجاد
                              نمی کند.</b-form-checkbox
                            ></b-form-group
                          >
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </b-tab>
        <b-tab
          v-if="role == 'manager' && proposal.status == 'پذیرش اولیه'"
          title="مدیریت وضعیت"
        >
          <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <template v-slot:header>
              <h4 class="mb-0">مدیریت وضعیت&nbsp;</h4>
            </template>

            <b-form-group
              id="fieldset-1"
              description
              label="وضعیت مقاله"
              aria-invalid="comments"
            >
              <b-form-group>
                <Select2
                  v-model="selectedSituation"
                  :options="[
                    { id: 'finalAccept', text: 'تایید نهایی' },
                    { id: 'rejected', text: 'رد شده است' },
                  ]"
                  :settings="{ width: '75%' }"
                ></Select2>
                <!-- <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select> -->
              </b-form-group>

              <b-form-group
                label="دلایل رد مقاله"
                v-if="selectedSituation == 'rejected'"
              >
                <v-select
                  multiple
                  :reduce="(x) => x.code"
                  :options="rejectOptions"
                  v-model="rejectCause"
                >
                </v-select>
              </b-form-group>
              <b-form-group v-else-if="selectedStatus == 3"></b-form-group>

              <b-form-group>
                <!-- NOTE (b-rejection) to submit reason for rejection -->
                <b-button
                  :disabled="disableEditProposal"
                  @click="editProposalManager"
                  >ثبت</b-button
                >
              </b-form-group>
            </b-form-group>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'referee'" title="داوری">
          <Review />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
// NOTE (FUNCTION) to check validation of the email address

import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import Review from "./ArticleReview"; // NOTE (IMPORT) to use reviewing component
const sarmadGantt = () => import("./sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search

export default {
  name: "Article",
  props: ["role"],
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    Review,
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
  },
  data() {
    return {
      refereeErrorHandler: false,
      oldData: [],
      pageLoaded: false,
      expireDisable: false,
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: [],
      rejectOptions: [],
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      reviewersData: [],
      reviewersFields: [],
      judgements: [],
      reviewers: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      situationsOptions: [
        {
          id: 12,
          eng: "draf",
          text: "پیش نویس",
          disabled: true,
        },
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "underSupervision", text: "درحال بررسی" },
        { id: 3, eng: "inviteReviewers", text: "در دست داوری" },
        { id: 4, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 5, eng: "approve", text: "پذیرش اولیه" },
        { id: 6, eng: "corrected", text: "اصلاح شده" },
        { id: 7, eng: "finalAccept", text: "تایید نهایی" },
        { id: 8, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 9, eng: "reject", text: "رد شده است" },
        { id: 10, eng: "declined", text: "لغو" },
      ],
      infoo: "",
      adminToReferee: "",

      moment: moment,
      selectedMehvar: 0,
      show: false,
      busy: false,
      fileBusy: true,
      initial: {},
      date: "",
      source: "",
      doi: "",
      specs: {},
      colleaguesData: [],
      serviceItems: [],
      rejectMessage: "",
      selectedColleague: "",
      executor: {},
      proposal: {},
      colleague: {},
      universities: [],
      mehvars: [],
      zone: new Array(6).fill(false),
      achievmentitems: [],
      tabIndex: 0,
      isLoaded: true,
      writersField: [
        { key: "index", label: "#" },
        { key: "nameEn", label: "نام و نام خانوادگی (انگلیسی)" },
        { key: "name", label: "نام و نام خانوادگی (فارسی)" },
        { key: "nationality", label: "ملیت" },
        { key: "position", label: "نقش نویسنده" },
      ],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      file: null,
      uploadedFiles: [],
      encouragement: "",
      promises: {},
      acc: 0,
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
    };
  },

  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$root.$emit("show::modal", "loading");

      this.busyAll = true;
      // rejections
      this.$http
        .post(
          this.baseUrl + "/setad/options/rejections",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.rejectOptions = res.data;
          this.rejectOptions.forEach((x) => {
            x.code = x.id;
            x.label = x.name;
          });

          acc++;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
      if (this.role == "admin") {
        let acc = 0;
        // admin universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              name: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // admin mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // admin companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت ها",
              })
            );

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // admin reviewers
        this.$http
          .post(
            this.baseUrl + "/setad/admin/reviewers/select",
            {
              projectId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.reviewersOptions = res.data;
            this.reviewersOptions.forEach((x) => {
              x.code = x.id;
              x.label = x.name;
            });

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////

        //////////////////////////////////////
        // admin getInfo
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/article/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.request;
            this.reviews = res.data.reviews;
            this.selectedSituation = this.situationsOptions.filter(
              (x) => x.text == this.proposal.status
            )[0].id;
            acc++;
            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.pageLoaded = true;
            }, 200);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "researcher") {
        let acc = 0;
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {});

        /////////////////////////////////////////////
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/article/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.pageLoaded = true;
            }, 200);
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }

            // this.additionalFiles = JSON.parse(res.data.project.files);

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            console.log(err);
            this.toast(err.response.data, "error");

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.show = true;
            }, 200);
          });
      } else if (this.role == "referee") {
        let acc = 0;
        // referee universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");

                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // referee mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        /////////////////////////////////////////////
        // referee companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت ها",
              })
            );
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        //////////////////////////////////////
        // referee getInfo
        this.$http
          .post(
            this.baseUrl + "/setad/reviewer/review/article/getInfo",
            {
              reviewId: this.$route.params.judgeId,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.request;
            this.proposal.adminToReferee = res.data.adminToReferee;

            this.acc++;
            this.$bvModal.hide("loading");
            this.pageLoaded = true;
            this.isLoaded = true;
            if (this.acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.show = true;
            }, 200);

            this.fileBusy = false;
          })
          .catch((err) => {
            this.refereeErrorHandler = true;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "manager") {
        let allUniMehvars = this.$http.post(
          this.baseUrl + "/setad/manager/allUniMehvarsBoth",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );
        let allUniversities = this.$http.post(
          this.baseUrl + "/setad/manager/allUniversities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );

        Promise.all([allUniMehvars, allUniversities]).then((res) => {
          let allMehv = res[0].data;
          let allUni = res[1].data;

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.mehvars = allMehv;
          this.mehvars.push(
            new Object({
              id: this.notMehvar,
              text: "سایر محورها",
              universityId: this.notUniversity,
            })
          );

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.universities = allUni;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه‌ها",
            })
          );
        });
      } else if (this.role == "head") {
        let acc = 0;

        // head universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              name: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // head mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // head companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت ها",
              })
            );

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // head reviewers
        this.$http
          .post(
            this.baseUrl + "/setad/head/reviewers/select",
            {
              projectId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.reviewersOptions = res.data;
            this.reviewersOptions.forEach((x) => {
              x.code = x.id;
              x.label = x.name;
            });

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        //////////////////////////////////////
        // head getInfo

        this.fileBusy = false;
        this.$http
          .post(
            this.baseUrl + "/setad/head/request/article/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.request;
            this.files = res.data.uploadedFiles;
            // this.pageLoaded = true;
            acc++;
            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.pageLoaded = true;
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
            }, 200);

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.notLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "university") {
        let acc = 0;
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {});

        /////////////////////////////////////////////
        this.$http
          .post(
            this.baseUrl + "/setad/university/request/article/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.pageLoaded = true;
            }, 200);
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }

            // this.additionalFiles = JSON.parse(res.data.project.files);

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            console.log(err);
            this.toast(err.response.data, "error");

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.show = true;
            }, 200);
          });
      }

      this.fileBusy = false;
      this.showProject();
    },
    getManagerInfo() {
      // NOTE (m-getManagerInfo) to get the proposal information and review details

      let rejectsPromise = this.$http.post(
        this.baseUrl + "/setad/manager/allrejections ",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        }
      );

      rejectsPromise.then((res3) => {
        this.rejectOptions.push(
          ...res3.data.map((x) => {
            return {
              code: x.id,
              label: x.name,
            };
          })
        );
      });

      this.$http
        .post(
          this.baseUrl + "/setad/manager/requestId",
          {
            projectId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.initial = JSON.parse(res.data.project.initial);
          this.promises = JSON.parse(res.data.project.promises);
          this.proposal.colleagues = JSON.parse(res.data.project.thirdStep);
          this.doi = res.data.project.doi;
          try {
            JSON.parse(res.data.project.secondStep).executor
              ? (this.executor = JSON.parse(
                  res.data.project.secondStep
                ).executor)
              : (this.executor = {});
          } catch (error) {
            this.executor = {};
          }
          try {
            this.judgements = JSON.parse(res.data.project.judgements);
          } catch (error) {
            this.judgements = [];
          }
          try {
            this.reviewerData = JSON.parse(res.data.project.reviewer);
          } catch (error) {
            this.reviewerData = [];
          }
          try {
            this.executor.universityJob = JSON.parse(
              JSON.parse(res.data.project.secondStep).description
            ).universityJob;
          } catch (error) {
            this.executor.universityJob = "";
          }
          this.uploadedFiles = res.data.project.files;
          this.proposal = res.data.project;

          this.selectedSituation = this.situationsOptions.find(({ text }) =>
            text.includes(this.proposal.status)
          ).id;
          this.proposal.typeStudy = JSON.parse(this.proposal.type).studies;
          this.proposal.typeSystemicDevelopmental = JSON.parse(
            this.proposal.type
          ).development;
          this.proposal.typePractical = JSON.parse(
            this.proposal.type
          ).practical;
          this.proposal.zoneMedicine = JSON.parse(this.proposal.zone).zone1;
          this.proposal.zoneAgriculture = JSON.parse(this.proposal.zone).zone2;
          this.proposal.zoneEnvironment = JSON.parse(this.proposal.zone).zone3;
          this.proposal.zoneIndustrial = JSON.parse(this.proposal.zone).zone4;
          this.proposal.zoneBioComputing = JSON.parse(this.proposal.zone).zone5;
          this.proposal.zoneOther = JSON.parse(this.proposal.zone).zone6;
          try {
            this.proposal.otherUniversity = JSON.parse(
              res.data.project.description
            ).proposal.otherUniversity;
          } catch (error) {
            this.proposal.otherUniversity = "";
          }

          try {
            this.proposal.otherMehvars = JSON.parse(
              res.data.project.description
            ).proposal.otherMehvars;
          } catch (error) {
            this.proposal.otherMehvars = "";
          }

          this.proposalInfo = {};
          try {
            this.specs = JSON.parse(res.data.project.secondStep).specs;
          } catch (error) {
            this.specs = {};
          }
          try {
            this.proposal.responsibleAuthor = JSON.parse(
              res.data.project.fourthStep
            );
          } catch (error) {
            this.proposal.responsibleAuthor = [];
          }

          this.serviceItems = {};

          this.acc++;

          if (this.acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
          setTimeout(() => {
            this.show = true;
          }, 200);

          this.fileBusy = false;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log({ err });
        });
    },
    hideModal(type) {
      // NOTE (m-hideModal) to hide loading
      this.$refs[type].hide();
    },
    removeJudge(row) {
      // NOTE (m-removeJudge) to specify selected judgment
      this.selectedJudgement = row.item;
      this.$root.$emit("show::modal", "delJudge");
      this.$bvModal.show("delJudge");
    },
    delJudge() {
      // NOTE (m-delJudge) to delete judgment
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/expireReview",
          {
            reviewId: this.selectedJudgement.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.$bvModal.hide("delJudge");
          this.onMounted();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    computedVariant(seed) {
      // REVIEW
      let variant = [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "dark",
        "info",
        "light",
      ];
      return variant[seed % 8];
    },
    editProposal(status) {
      // NOTE (m-editProposal) to submit proposal changes
      this.$bvModal.show("loading");

      if (status == "inviteReviewers") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/article/" + status,
            {
              requestId: this.$route.params.id,
              description: this.proposal.description,
              referees: this.reviewers,
              adminToReferee: this.proposal.adminToReferee,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              this.$router.push("/admin/activeArticles");
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (status == "reject") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/article/" + status,
            {
              requestId: this.$route.params.id,
              rejectionIds: this.proposal.rejectionIds,
              description: this.proposal.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              this.$router.push("/admin/canceledArticles");
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/article/" + status,
            {
              requestId: this.$route.params.id,
              description: this.proposal.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
              if (this.selectedSituation == 8) {
                this.$router.push("/admin/needEditArticles");
              } else if (this.selectedSituation == 7) {
                this.$router.push("/admin/decidedArticles");
              } else {
                this.$router.push("/admin/activeArticles");
              }
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
    },
    submitComment() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/editRequestId",
          {
            projectId: this.$route.params.id,
            projectType: "article",
            description: JSON.stringify({
              description: this.comments,
              score: this.score,
            }),
            rejection_id: JSON.stringify(this.rejectCause),
            situation: this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].eng,
            referees:
              this.reviewersData.length > 1
                ? String(this.reviewersData)
                : this.reviewersData.length
                ? String(this.reviewersData[0])
                : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        ) // REVIEW
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (res.status == 200) {
            this.acc = 2;
            setTimeout(() => {
              this.showProject();
            }, 300);
            this.comments = "";
            this.toast(res.data, "success");
          }
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    editProposalManager() {
      // NOTE (m-editProposalManager) to submit reason for rejection
      this.$bvModal.show("loading");
      this.isLoaded = false;
      // this.disableEditProposal = true;
      let editProposal = this.$http.post(
        this.baseUrl + "/setad/manager/confirmationRequestId",
        {
          projectId: this.$route.params.id,
          projectType: "article",
          rejection_id: JSON.stringify(this.rejectCause),
          situation: this.selectedSituation,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        }
      );

      editProposal // REVIEW
        .then((res) => {
          this.proposal.status = this.selectedSituation;
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.$router.push("/manager/needArticles");
          }
        })
        .catch((err) => {
          this.getManagerInfo();
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    showProject() {
      if (this.role == "researcher") {
        let rejectsPromise = this.$http.post(
          this.baseUrl + "/setad/researcher/allrejections",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );

        rejectsPromise.then((res3) => {
          this.rejectOptions.push(
            ...res3.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          );
        });
      } else if (this.role == "manager") {
        this.getManagerInfo();
      }
    },
  },
  computed: {
    computedSelectedReferees() {
      let referees = this.reviewersFields.filter(
        (x) => this.reviewers.indexOf(x.code) != -1
      );
      return referees;
    },
    computedOldData() {
      try {
        this.oldData.splice(this.oldData.length - 1, 1);
        return this.oldData;
      } catch (error) {
        return [];
      }
    },
    computedJournals() {
      if (this.proposal.history) {
        return this.proposal.history.sort((a, b) => {
          if (a.timeStamp < b.timeStamp) {
            return 1;
          }
          if (a.timeStamp > b.timeStamp) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
    computedJudgements() {
      if (this.proposal.judgements) {
        this.proposal.judgements.forEach((element) => {
          this.$set(element, "_showDetails", false);
          this.$set(element, "isActive", false);
        });

        return this.proposal.judgements;
      } else return [];
    },
    disableEditProposal() {
      if (this.selectedSituation) {
        if (this.selectedSituation == 8) {
          if (!this.proposal.description) {
            return true;
          } else return false;
        }
        if (this.selectedSituation == 3 && this.reviewers.length == 0)
          return true;
        if (this.selectedSituation == 9 && !this.proposal.rejectionIds.length)
          return true;
        if (this.selectedSituation == 10 && !this.proposal.description)
          return true;
        return false;
      } else return true;
    },
  },
  mounted() {
    this.onMounted();
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5>کندی سرعت اینترنت...</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید.
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
  updated() {},
};
</script>
<style lang="scss" scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  h5 {
    color: #fff !important;
  }
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  h5 {
    color: #fff !important;
  }
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  h5 {
    color: #fff !important;
  }
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  h5 {
    color: #fff !important;
  }
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  h5 {
    color: #fff !important;
  }
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}

#vs1__listbox {
  text-align: right;
  direction: rtl;
}
</style>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
</style>
